import { createAuthClient } from 'better-auth/react';

// Use current origin on the client to avoid cross-origin cookie issues
// that can prevent session detection on direct deep links (e.g. /timeline).
const resolveBaseUrl = (): string => {
  const browserOrigin = globalThis.window?.location?.origin;
  if (typeof browserOrigin === 'string' && browserOrigin.length > 0) {
    return browserOrigin;
  }

  // biome-ignore lint/style/noProcessEnv: Client-side runtime env access required for dynamic base URL resolution
  const { NEXT_PUBLIC_APP_URL: configuredBaseUrl } = process.env;
  if (typeof configuredBaseUrl === 'string' && configuredBaseUrl.length > 0) {
    return configuredBaseUrl;
  }

  return 'http://localhost:3000';
};

export const authClient = createAuthClient({
  baseURL: resolveBaseUrl(),
});

// Export commonly used hooks
export const { useSession, signIn, signOut } = authClient;
